// Shape written by teamstore-closeout POST /payout/quarter (PR 357).
// Console only reads teamStorePayouts — it does not run the job.

export type PayoutRow = {
  id: string;
  storeId?: string;
  storeName?: string;
  year?: number | null;
  quarter?: number | null;
  periodStart?: string | null;
  periodEnd?: string | null;
  revenue?: number;
  teamCommission?: number;
  salesRepCommission?: number;
  orderCount?: number;
  totalUnits?: number;
  commissionRate?: number;
  salesRepCommissionRate?: number;
  salesRepName?: string;
  sentAt?: string | null;
  emailStatus?: string;
  createdAt?: string | null;
};

export function dollars(n?: number | null): string {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function periodLabel(p: PayoutRow): string {
  if (p.year && p.quarter) return `${p.year} Q${p.quarter}`;
  const id = String(p.id || '');
  const m = /_(\d{4})Q([1-4])$/.exec(id);
  if (m) return `${m[1]} Q${m[2]}`;
  return p.id || '—';
}

export function ratePct(rate: number | null | undefined, fallback: number): string {
  if (rate == null || Number.isNaN(Number(rate))) return `${fallback}%`;
  const n = Number(rate);
  return `${Math.round(n <= 1 ? n * 100 : n)}%`;
}

const STATUS_TONE: Record<string, string> = {
  sent: 'bg-success/10 text-success',
  pending: 'bg-warning/10 text-warning',
  failed: 'bg-danger/10 text-danger',
  no_valid_recipients: 'bg-bg text-muted',
};

export function payoutStatus(p: PayoutRow): { label: string; className: string } {
  const raw = String(p.emailStatus || (p.sentAt ? 'sent' : 'pending')).toLowerCase();
  const labels: Record<string, string> = {
    sent: 'Sent',
    pending: 'Pending',
    failed: 'Failed',
    no_valid_recipients: 'No recipients',
  };
  return { label: labels[raw] || raw.replace(/_/g, ' '), className: STATUS_TONE[raw] || 'bg-bg text-muted' };
}
